import { render } from "./goodneet.vue?vue&type=template&id=47773243"
import script from "./goodneet.vue?vue&type=script&lang=js"
export * from "./goodneet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__